import styles from "../../../src/styles/Blog/TodaysUpdate.module.css";
const TodaysUpdate = () => {
  return (
    <div className={styles.todaysUpdateContainer}>
      <div className={styles.todaysUpdateTitle}>Today’s Update</div>
      <div className={styles.todaysUpdateBoxContainer}>
        <div className={styles.todaysUpdateBox}>
          <div className={styles.todaysCount}>14</div>
          <div>New Posts</div>
        </div>
        <div className={styles.todaysUpdateBox}>
          <div className={styles.todaysCount}>480</div>
          <div>Total Visitors</div>
        </div>
        <div className={styles.todaysUpdateBox}>
          <div className={styles.todaysCount}>29</div>
          <div>New Subscribers</div>
        </div>
        <div className={styles.todaysUpdateBox}>
          <div className={styles.todaysCount}>138</div>
          <div>Blog Read</div>
        </div>
      </div>
    </div>
  );
};

export default TodaysUpdate;
